import { render, staticRenderFns } from "./SpeedometerSvg.vue?vue&type=template&id=2db85ce0&"
import script from "./SpeedometerSvg.vue?vue&type=script&lang=ts&"
export * from "./SpeedometerSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports